export default __webpack_public_path__ + "static/media/img-4.d8a58ef2.png";